var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10629_6444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5109 0H9.77497C9.11478 0 8.57153 0.543245 8.57153 1.20344V2.57134L16.8772 5.14293L25.7143 2.57134V1.20344C25.7143 0.543245 25.1711 0 24.5109 0Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1286 13.2045C27.2542 12.8099 27.3544 12.4076 27.4286 12.0002C27.4288 11.7963 27.3198 11.6074 27.1432 11.5056L27.1321 11.4996L27.1286 11.4979L17.8389 6.20589C17.7989 6.17996 17.7573 6.15614 17.7147 6.1347C17.355 5.9564 16.9318 5.9564 16.5721 6.1347C16.5295 6.15614 16.4879 6.17983 16.4478 6.20589L7.15814 11.4979L7.15465 11.4996L7.14343 11.5056C6.967 11.6074 6.85803 11.7963 6.85815 12.0002C6.93234 12.4076 7.03259 12.8099 7.15814 13.2045L17.0084 20.4087L27.1286 13.2045Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 2.57129H14.5715L12.8391 5.14288L14.5715 7.71422L20.5715 12.857H25.7143V7.71422L20.5715 2.57129Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57153 2.57129H14.5715V7.7141H8.57153V2.57129Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5715 2.57129H25.7143V7.7141H20.5715V2.57129Z",
    fill: "#50D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 12.8567L14.5715 7.71387H8.57153V12.8567L14.5715 17.9996L23.8561 19.515L20.5715 12.8567Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5715 7.71387H20.5715V12.8567H14.5715V7.71387Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57153 12.8574H14.5715V18.0002H8.57153V12.8574Z",
    fill: "#064A8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5715 12.8574H25.7143V18.0002H20.5715V12.8574Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3067 19.9007L7.19751 12.5293L7.62093 11.7845C7.62093 11.7845 16.8309 17.0301 16.9714 17.1091C17.0879 17.1558 17.2188 17.1521 17.3324 17.0987C17.4634 17.025 26.7026 11.7588 26.7026 11.7588L27.1277 12.5036L17.3067 19.9007Z",
    fill: "#0A2767",
    fillOpacity: 0.498039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1432 12.4945L27.1321 12.5014L27.1295 12.5031L17.8398 17.7952C17.465 18.0368 16.9902 18.0663 16.5884 17.8731L19.824 22.2111L26.8989 23.7514V23.7549C27.2325 23.5136 27.4305 23.126 27.4303 22.7143V12C27.4305 12.2037 27.3214 12.3928 27.1449 12.4945H27.1432Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4285 22.7141V22.0815L18.8716 17.2061L17.8387 17.7941C17.4641 18.0357 16.9893 18.0654 16.5874 17.872L19.8231 22.2101L26.898 23.7503V23.7538C27.2315 23.5124 27.4294 23.1249 27.4294 22.7132L27.4285 22.7141Z",
    fill: "black",
    fillOpacity: 0.047059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3857 23.0417L18.0059 17.6982L17.8387 17.7934C17.4641 18.035 16.9893 18.0647 16.5874 17.8713L19.8231 22.2094L26.898 23.7496V23.7531C27.138 23.579 27.3107 23.3273 27.3865 23.0408L27.3857 23.0417Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15718 12.5057V12.4971H7.14871L7.1229 12.48C6.95657 12.3777 6.85558 12.1953 6.8572 12V22.716C6.8572 23.4204 7.43685 24 8.14131 24H26.1431C26.25 23.9989 26.3566 23.9845 26.4601 23.9571C26.5139 23.9478 26.5659 23.9304 26.6145 23.9057C26.6327 23.9039 26.6502 23.898 26.6659 23.8885C26.7359 23.8599 26.8023 23.8225 26.863 23.7771L26.8973 23.7514L7.15718 12.5057Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 19.4284V5.42873C15.4268 4.80257 14.9122 4.288 14.2861 4.28613H8.59813V10.6769L7.15716 11.4981L7.1538 11.4998L7.1427 11.5058C6.96615 11.6078 6.85718 11.7967 6.85718 12.0003V20.5744V20.5709H14.2861C14.9122 20.5691 15.4268 20.0544 15.4286 19.4284Z",
    fill: "black",
    fillOpacity: 0.098039
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5716 20.2858V6.28615C14.5697 5.66012 14.055 5.14555 13.429 5.14355H8.59813V10.6772L7.15716 11.4984L7.1538 11.5002L7.1427 11.5061C6.96615 11.6081 6.85718 11.797 6.85718 12.0006V21.4319V21.4284H13.429C14.055 21.4266 14.5697 20.912 14.5716 20.2858ZM14.5716 18.5716V6.28615C14.5697 5.66012 14.055 5.14555 13.429 5.14355H8.59813V10.6772L7.15716 11.4984L7.1538 11.5002L7.1427 11.5061C6.96615 11.6081 6.85718 11.797 6.85718 12.0006V19.7175V19.7142H13.429C14.055 19.7123 14.5697 19.1977 14.5716 18.5716ZM13.7144 18.5716V6.28615C13.7125 5.66012 13.1979 5.14555 12.5719 5.14355H8.59813V10.6772L7.15716 11.4984L7.1538 11.5002L7.1427 11.5061C6.96615 11.6081 6.85718 11.797 6.85718 12.0006V19.7175V19.7142H12.5719C13.1979 19.7123 13.7125 19.1977 13.7144 18.5716Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1426 5.14258H12.5708C13.1976 5.14258 13.7134 5.65827 13.7134 6.28505V17.7134C13.7134 18.3402 13.1976 18.856 12.5708 18.856H1.1426C0.515815 18.856 0 18.3402 0 17.7134V6.28505C0 5.65827 0.515815 5.14258 1.1426 5.14258Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31447 9.82906C3.61808 9.18208 4.10833 8.64058 4.72189 8.27426C5.40179 7.885 6.17595 7.69111 6.95909 7.71368C7.68437 7.69772 8.4003 7.88163 9.0282 8.24508C9.61908 8.59694 10.095 9.11313 10.3978 9.73056C10.7278 10.4108 10.8923 11.1594 10.8779 11.9154C10.894 12.7055 10.7245 13.4885 10.3834 14.2014C10.0738 14.8407 9.58354 15.3755 8.97334 15.7392C8.321 16.1141 7.57839 16.303 6.82617 16.2852C6.08518 16.3027 5.35342 16.1168 4.7108 15.7476C4.11531 15.3952 3.63366 14.8785 3.32395 14.2597C2.99192 13.5891 2.82546 12.8486 2.83881 12.1005C2.82409 11.3172 2.98705 10.5406 3.31535 9.82906H3.31447ZM4.81441 13.4788C4.97637 13.8879 5.25105 14.2428 5.60652 14.5022C5.96823 14.7555 6.40188 14.8862 6.84326 14.8751C7.31356 14.8937 7.77726 14.7589 8.16415 14.4911C8.51526 14.2317 8.7827 13.8749 8.93307 13.4651C9.10214 13.0082 9.18543 12.5241 9.17907 12.0371C9.18431 11.5458 9.10601 11.0571 8.94766 10.592C8.80801 10.1733 8.55017 9.80375 8.20529 9.52832C7.82863 9.24704 7.36618 9.10415 6.8965 9.12372C6.44552 9.112 6.00214 9.24342 5.63046 9.49915C5.26838 9.75936 4.9876 10.1173 4.82127 10.5311C4.45345 11.4786 4.45133 12.5299 4.81528 13.4788H4.81441Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10629_6444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.4303,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/Outlook.1ef59450.svg";
export { ForwardRef as ReactComponent };